class ImageCarousel extends HTMLElement {
  constructor() {
    super();
    this.sliderWrapper = this.querySelector('.image-carousel__slider__wrapper');
    this.progressBar = this.querySelector('.image-carousel__slider__progress-bar');
    this.slider = new Flickity(this.sliderWrapper, JSON.parse(this.sliderWrapper.dataset.flickityConfig));
    this.querySelectorAll('.custom-flickity-button').forEach((button) => {
      button.addEventListener('click', this.handlePrevNextClick.bind(this));
    });
    this.setProgressBarAnimation();
  }

  connectedCallback() {}
  handlePrevNextClick(event) {
    const button = event.currentTarget;
    const direction = button.classList.contains('previous') ? 'previous' : 'next';
    this.slider[direction]();
  }

  setProgressBarAnimation() {
    this.slider.on('scroll', (progress) => {
      progress = Math.max(0, Math.min(1, progress));
      this.progressBar.style.width = progress * 100 + '%';
    });
  }
}
customElements.define('image-carousel', ImageCarousel);
